export const IMAGES_ONLY = 'imagesOnly';
export const SLIDES = 'slides';
